import { Form, Row, Col, Button, InputGroup } from "react-bootstrap";
import Select from "react-select";
import { useDispatch, useSelector } from "react-redux";
import Flatpickr from "react-flatpickr";
import { CiSearch } from "react-icons/ci";
import {
  setActiveTab,
  setPaginationPageNumber,
  TriggerFilterButtonApi,
} from "../../../slices/common/reducer";
import { setQuoteFilterForm } from "../../../slices/orders/orderSlice";
import {
  filterDateOptions,
  handleFilterDateChange,
} from "../../../Utils/CommonUtils";
import { QOT_FROM_DATE, QOT_TO_DATE } from "../../../Utils/FilterDateKeys";
import "../Orders/Order.scss";

const QuoteFilter = () => {
  const dispatch = useDispatch();

  const filterForm = useSelector((state) => state.order.quoteFilter.form);

  const resetTabAndPageNumber = () => {
    dispatch(setPaginationPageNumber(0));
    dispatch(setActiveTab("ALL"));
  };

  const handleInputChange = (name, value) => {
    dispatch(setQuoteFilterForm({ name, value }));
    resetTabAndPageNumber();
    dispatch(TriggerFilterButtonApi());
  };

  const handleClear = () => {
    dispatch(setQuoteFilterForm({ type: "reset" }));

    dispatch(TriggerFilterButtonApi());

    if (Object.keys(filterForm).length > 0) {
      resetTabAndPageNumber();
    }
  };

  const quoteStatusOptions = [
    { value: "ACTIVE", label: "Active" },
    { value: "CONVERTED", label: "Converted" },
  ];

  const isClearButtonDisabled = !Object.values(filterForm).some(
    (value) => value
  );

  return (
    <div className="filter-wrapper">
      <Form className="form-input">
        <Row>
          <Form.Group as={Col} className="col-md-4">
            <InputGroup>
              <InputGroup.Text id="basic-addon1">
                <CiSearch />
              </InputGroup.Text>
              <Form.Control
                type="text"
                placeholder="Search for Quote..."
                name="filter_ref"
                id="code"
                className="order-searchbar"
                value={filterForm.filter_ref || ""}
                onChange={(e) =>
                  handleInputChange(e.target.name, e.target.value)
                }
              />
            </InputGroup>
          </Form.Group>

          <Form.Group as={Col} className="col-md-4">
            <Flatpickr
              className="form-control border-lightgrey"
              placeholder="Select date range"
              data-input
              options={filterDateOptions}
              value={[
                filterForm[QOT_FROM_DATE]
                  ? new Date(filterForm[QOT_FROM_DATE])
                  : null,
                filterForm[QOT_TO_DATE]
                  ? new Date(filterForm[QOT_TO_DATE])
                  : null,
              ]}
              onChange={(e) =>
                handleFilterDateChange(
                  e,
                  setQuoteFilterForm,
                  QOT_FROM_DATE,
                  QOT_TO_DATE
                )
              }
            />
          </Form.Group>

          <Form.Group as={Col} className="col-md-3">
            <Select
              isClearable
              placeholder="All"
              name="status"
              options={quoteStatusOptions}
              value={
                quoteStatusOptions.find(
                  (itm) => itm.value === filterForm.status
                ) || null
              }
              onChange={(e) => handleInputChange("status", e ? e.value : "")}
            />
          </Form.Group>
          <Form.Group as={Col} className="col-md-1">
            <div>
              <Button
                className="primary-outline"
                onClick={handleClear}
                disabled={isClearButtonDisabled}
              >
                Clear
              </Button>
            </div>
          </Form.Group>
        </Row>
      </Form>
    </div>
  );
};

export default QuoteFilter;
